import './EnrollmentProgressStepper.css';
import {Tooltip} from 'react-tooltip';
import {enrolmentValidation} from "../Utils/PlanUtils";
import {useTranslation} from "react-i18next";

const EnrollmentProgressStepper = ({ state, hideLabels }) => {

    const {t} = useTranslation();

    let progress = [
        {
            label: t('Enrolment Validated'),
            completed: state.plan ? enrolmentValidation(state).length === 0 : state.validated || state.enrollment.validated,
        },
        {
            label: t('Awaiting Signatures'),
            completed: state.enrollment.state !== 'pre-docusign' && state.docusign.status !== 'pre-docusign',
        },
        {
            label: t('Signing Completed'),
            completed: state.docusign.status === 'completed' || state.enrollment.state === 'docusign-completed' || state.enrollment.state === 'enrolment-review-uploaded',
        },
        {
            label: t('Enrolment Review'),
            completed: state.enrollment.state === 'enrolment-review-uploaded',
        },

    ]

    return (
        <div className={'enrollment-progress-stepper'}>
            {progress.map((step, index) => {
                return [(
                    <div className={'progress-step' + (step.completed ? ' completed' : '') + (hideLabels ? ' hidden-labels' : '')} key={index}>
                        <span className={'material-symbols-outlined'}
                              data-tooltip-content={step.label}
                              data-tooltip-id={'tooltip'}
                              data-tooltip-place="bottom"
                        >
                            {step.completed ? 'check_circle' : 'circle'}
                        </span>
                        {!hideLabels &&
                            <div className={'step-label'}>{step.label}</div>
                        }
                    </div>
                ), index < progress.length - 1 && (
                    <div className={'progress-line-segment' + (progress[index+1].completed ? ' completed' : '') + (step.completed && !progress[index+1].completed ? ' in-progress' : '')} key={`ls${index}`}></div>
                )]
            })}

            <Tooltip id={'tooltip'} className={'enrollment-progress-stepper-tooltip'} />
        </div>
    )
}

export default EnrollmentProgressStepper;